import { axiosServerless } from 'actions';

/**
 * Fetches payment API responses from a given URL.
 * @param {string} url - The URL to fetch the payment API responses from.
 * @returns {Promise<any>} A promise that resolves with the data from the response.
 */
export const getPaymentAPIResponses = (url: string) => {
  return axiosServerless
    .get(url)
    .then(({ data }) => data)
    .catch((error) => {
      const errorMessage = error?.response?.data || error.message || error;
      return Promise.reject(errorMessage);
    });
};
